import { render, staticRenderFns } from "./ConfigAdmin.vue?vue&type=template&id=127eb45b&scoped=true"
import script from "./ConfigAdmin.vue?vue&type=script&lang=js"
export * from "./ConfigAdmin.vue?vue&type=script&lang=js"
import style0 from "./ConfigAdmin.vue?vue&type=style&index=0&id=127eb45b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127eb45b",
  null
  
)

export default component.exports